<script lang="ts">
import FicheSalarieList from '@/generated/fiches/FicheSalarieList.vue';
import { defineComponent } from "vue";

export default defineComponent({
  components: {},
  extends: FicheSalarieList,
  data() {
    return {
      cardView: true
    }
  },
  methods: {
    isDisplayed(value: string): boolean {
      return true;
    }
  }
})

</script>
